import ScopeFilter from './ScopeFilter';

export default ScopeFilter;
